import { createRoute } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { appRoute } from "./route";

const AssetListView = lazy(async () => {
  const m = await import("@/features/assets/components/asset-list-view");
  return { default: m.AssetListView };
});

function AssetsPage() {
  return (
    <Suspense fallback={null}>
      <AssetListView />
    </Suspense>
  );
}

/**
 * Deep-linkable overlays for asset list. URL is source of truth:
 *   `?new=1`        → "new asset" dialog
 *   `?delete=<id>`  → deletion confirmation for specific asset
 */
export interface AssetsSearch {
  new?: boolean;
  delete?: string;
}

export const assetsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/assets",
  component: AssetsPage,
  validateSearch: (search: Record<string, unknown>): AssetsSearch => ({
    // Includes NUMBER 1: TanStack auto-parses pasted `?new=1` to number 1 (not
    // string), and without this case param was discarded and router REMOVED it on
    // boot → creation dialog did not open via deep-link (CC-18).
    new:
      search.new === true || search.new === 1 || search.new === "1" || search.new === "true"
        ? true
        : undefined,
    delete:
      typeof search.delete === "string" && search.delete.trim() !== "" ? search.delete : undefined,
  }),
});
